import { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { Table } from "./Table";

export const RevenueReportRecruiterHead = () => {
    const toast = useRef<any>(null);
    return (
        <>
            <Table toast={toast} />
            <Toast ref={toast} />
        </>
    );
}